import React from "react";
// react plugin used to create DropdownMenu for selecting items
import Select2 from "react-select2-wrapper";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Form,
  Input,
  Modal,
  Row,
  Col,
} from "reactstrap";

class List extends React.Component {

  render() {
    return (
      <>
        <Modal
            className="modal-dialog-centered"
            size="lg"
            isOpen={this.props.modalOpened}
            autoFocus={false}
        >
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {this.props.title}
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={(e) => this.props.modalSave(e, "abort")}
              disabled={this.props.saving}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <Row>
            <div className="col">
              <div className="card-wrapper">
                <Card>
                  <CardBody>
                    <Form className="needs-validation" noValidate autoComplete="off">
                    <div className="form-row">
                      <Col className="mb-3" md="6">
                        <label
                          className="form-control-label"
                          htmlFor="validationCustom01"
                        >
                          Nome
                        </label>
                          <Input
                            autoFocus
                            id="validationCustom01"
                            placeholder="Nome da lista"
                            type="text"
                            value={this.props.listName}
                            readOnly={this.props.readOnly}
                            disabled={this.props.saving}
                            valid={
                            this.props.customStyles.listNameState === "valid"
                          }
                          invalid={
                            this.props.customStyles.listNameState === "invalid"
                          }
                          onChange={e =>
                            this.props.stylesForm(e, "listName")
                          }
                        />
                        <div className="invalid-feedback">
                          Digite o nome da lista.
                        </div>
                      </Col>
                      <Col className="mb-3" md="6">
                        <label
                          className="form-control-label"
                          htmlFor="validationCustom04"
                        >
                          Gestor Golive
                        </label>
                        <Select2
                            className="form-control"
                            type="text"
                            value={this.props.listManagerCG}
                            disabled={this.props.readOnly || this.props.saving || !this.props.isManagerConsulting}
                            onSelect={e => this.props.stylesForm(e, "listManagerCG")}
                            options={{
                              placeholder:"Selecione um gestor da Golive",
                              language: {
                                noResults: function() {
                                  return "Nenhum gestor encontrado."
                                },
                              },
                            }}
                            data={this.props.managerCGList}
                          />
                          <Input
                            hidden
                            valid={this.props.customStyles.listManagerCGState === "valid"}
                            invalid={this.props.customStyles.listManagerCGState === "invalid"}
                          />
                          <div className="invalid-feedback">
                            Gestor inválido ou não selecionado
                          </div>
                      </Col>
                    </div>
                    <div className="form-row">
                    <Col className="mb-3" md="6">
                        <label
                          className="form-control-label"
                          htmlFor="validationCustom04"
                        >
                          Gestor Cliente
                        </label>
                        <Select2
                            className="form-control"
                            type="text"
                            value={this.props.listManagerCR}
                            disabled={this.props.readOnly || this.props.saving}
                            onSelect={e => this.props.stylesForm(e, "listManagerCR")}
                            options={{
                              placeholder:"Selecione um gestor do cliente",
                              language: {
                                noResults: function() {
                                  return "Nenhum gestor encontrado."
                                },
                              },
                            }}
                            data={this.props.managerCRList}
                          />
                          <Input
                            hidden
                            valid={this.props.customStyles.listManagerCRState === "valid"}
                            invalid={this.props.customStyles.listManagerCRState === "invalid"}
                          />
                          <div className="invalid-feedback">
                            Gestor inválido ou não selecionado.
                          </div>
                      </Col>
                    </div>
                  </Form>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Row>
          <div className="modal-footer">
            <Button
                color="danger"
                data-dismiss="modal"
                type="button"
                onClick={(e) => this.props.modalSave(e, "abort")}
                disabled={this.props.saving}
            >
                Cancelar
            </Button>
            <Button
                color="success"
                type="button"
                onClick={(e) => this.props.modalSave(e)}
                hidden={this.props.crud === "R"}
                disabled={this.props.saving}
            >
                {this.props.crud === "D" ? ("Excluir"):("Salvar")}
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

export default List;